import React, { createContext } from "react";

export const filterContext = createContext({
  items: [
    {
      columnField: "id",
      operator: "contains",
      operatorValue: "contains",
      value: "",
    },
  ],
});
export const { Provider } = filterContext;
